export const baseUrl = 'https://cp.mojezeh-ar.ir/api';// 'http://localhost:24702/api';
export const httpPromise = function (component, url, method, data, successCallback, errorCallback) {
 
    switch (method.toLocaleLowerCase().trim()) {
        //********************************************************************************************************************************
        case 'get':
            component.$http.get(baseUrl + url, { params: data, headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } }).then(
                response => {
                    if (successCallback != null)
                        successCallback(response);
                },
                response => {
                    if (response.status == 401) {
                        localStorage.removeItem('accessToken');
                        component.$router.push('/');
                    }
                    if (response.status == 400) {
                        if (errorCallback != null)
                            errorCallback(response);
                    } else {
                        toastr.error('خطا در ارتباط با سرور');
                    }
                });
            break;
        //********************************************************************************************************************************
        case 'post':
            component.$http.post(baseUrl + url, data, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } }).then(
                response => {
                    if (successCallback != null)
                        successCallback(response);
                },
                response => {
                    if (response.status == 401) {
                        localStorage.removeItem('accessToken');
                        component.$router.push('/');
                    }
                    if (response.status == 400) {
                        if (errorCallback != null)
                            errorCallback(response);
                    } else {
                        toastr.error('خطا در ارتباط با سرور');
                    }
                });
            break;
        //********************************************************************************************************************************
        case 'delete':
            component.$http.delete(baseUrl + url, { params: data, headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } }).then(
                response => {
                    if (successCallback != null)
                        successCallback(response);
                },
                response => {
                    if (response.status == 401) {
                        localStorage.removeItem('accessToken');
                        component.$router.push('/');
                    }
                    if (response.status == 400) {
                        if (errorCallback != null)
                            errorCallback(response);
                    } else {
                        toastr.error('خطا در ارتباط با سرور');
                    }
                });
            break;
        case 'put':
            component.$http.put(baseUrl + url, data, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } }).then(
                response => {
                    if (successCallback != null)
                        successCallback(response);
                },
                response => {
                    if (response.status == 401) {
                        localStorage.removeItem('accessToken');
                        component.$router.push('/');
                    }
                    if (response.status == 400) {
                        if (errorCallback != null)
                            errorCallback(response);
                    } else {
                        toastr.error('خطا در ارتباط با سرور');
                    }
                });
            break;
    }

}

export const htmlLoader = function (component, url, successCallback, errorCallback) {
    component.$http.get(url).then(
        response => {
            if (successCallback != null)
                successCallback(response);
        },
        response => {
            if (errorCallback != null)
                errorCallback(response);
        });
}